// this helper reolves to the default scoped FAQ when no custom help link is passed
const createHelpLink = (locale, pathname) => {
    let faqUrl = `https://faq.xing.com/${locale === 'de' ? 'de' : 'en'}`;
    let match = /(\/app\/|\/)(\w+-?\w+)([?/]|$)/.exec(pathname);
    faqUrl += match && match.length > 2 ? `?app=${match[2]}` : '';
    return faqUrl;
};
export { createHelpLink };
//# sourceMappingURL=utils.js.map